var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4626",
    "data-name": "Raggruppa 4626",
    transform: "translate(-24 -190)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2109",
    "data-name": "Rettangolo 2109",
    width: 24,
    height: 24,
    transform: "translate(24 190)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4623",
    "data-name": "Raggruppa 4623",
    transform: "translate(-6 -160.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_zocial-email",
    "data-name": "Icon zocial-email",
    d: "M.072,16.219V5.249q0-.019.057-.362L6.586,10.41.148,16.6a1.614,1.614,0,0,1-.076-.381ZM.929,4.125a.821.821,0,0,1,.324-.057H18.641a1.078,1.078,0,0,1,.343.057L12.509,9.667l-.857.686-1.7,1.39-1.7-1.39L7.4,9.667ZM.948,17.343l6.494-6.228,2.514,2.038,2.514-2.038,6.494,6.228a.914.914,0,0,1-.324.057H1.253a.863.863,0,0,1-.3-.057ZM13.328,10.41l6.437-5.523a1.137,1.137,0,0,1,.057.362v10.97a1.46,1.46,0,0,1-.057.381Z",
    transform: "translate(31.928 351.266)",
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.467b0533d695acfcd2165f54ba166a49.svg";
export { ForwardRef as ReactComponent };